/** 神策数据分析接入 */
import sensors from "sa-sdk-javascript"

/** 初始化创建 */
sensors.init({
  /**
   * @constant server_url
   * @description 事件发送地址，此地址对应着神策数据统计后台
   * @query token
   * @query project
   */
  server_url: process.env.SENSORS_BACKEND_SERVER_PATH,
  // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  is_track_single_page: false,
  // 使用客户端时间
  use_client_time: true,
  /**
   * 发送的事件类型
   */
  send_type: "beacon",
  /**
   * 是否打印事件日志
   */
  show_log: process.env.MODE !== "prod",
  /**
   * 心电图
   */
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: "not_collect",
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: "not_collect",
  },
})

sensors.quick("autoTrackSinglePage")

let i = 0
/** 注册公共属性 */
sensors.registerPage({
  current_url: window.location.href,
  referrer: document.referrer,
  /** selfIncrease page index */
  index: function () {
    return i++
  },
})

// /**
//  * 打印prop
//  */
// if (process.env.UMI_ENV === "dev") {
//   console.log(sensors.getPresetProperties())
// }

/** 挂载到全局 */
window.sensors = sensors
